function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 9.41935C1.75 6.84054 3.84054 4.75 6.41935 4.75H10.4839C13.0627 4.75 15.1532 6.84054 15.1532 9.41935C15.1532 11.9982 13.0627 14.0887 10.4839 14.0887H6.41935C3.84054 14.0887 1.75 11.9982 1.75 9.41935Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3783 8.74193H13.1935C10.5746 8.74193 8.4516 10.865 8.4516 13.4839C8.4516 16.1028 10.5746 18.2258 13.1935 18.2258H17.2581C19.877 18.2258 22 16.1028 22 13.4839V13.0528C22 10.672 20.07 8.74193 17.6891 8.74193",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgCopy2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Copy-2.0f6a8707.svg";
export { ForwardRef as ReactComponent };